import Modal from 'components/commons/modal/Modal2';
import React from 'react';
import { isIosAppNotPremium } from '../utils/userStatus';

export const DisplayableAssetTypeModal = ({
  hide,
  isShowModal,
  isMoneytree,
}: {
  isShowModal: boolean;
  hide: () => void;
  isMoneytree: boolean;
}): React.ReactElement => {
  return (
    <>
      <Modal {...{ isShow: isShowModal, close: hide }}>
        <div className={`ui-border-b flex flex-col py-4 px-2`}>
          <div className="flex flex-row pb-4 px-4">
            <div className={`text-bluegray-700 font-bold text-lg`}>
              表示できる資産種別
            </div>
            <div
              className="icon-close text-bluegray-400 ml-auto text-lg cursor-pointer"
              onClick={hide}></div>
          </div>
          {!isMoneytree && (
            <div className="text-bluegray-700 text-base font-bold mx-2">
              みんかぶ口座連携
            </div>
          )}
          <img
            src={
              isMoneytree
                ? '/static/images/data_renkei_table_MT.jpg'
                : '/static/images/data_renkei_table.png'
            }
            className="p-2"
            alt=""
          />
          {!isIosAppNotPremium() && !isMoneytree && (
            <div className={`px-2 text-bluegray-500 text-xs`}>
              ※現在、マネックス証券と総合証券は取引履歴は表示されません。
            </div>
          )}
          {!isMoneytree && (
            <>
              <div className="text-bluegray-700 text-base font-bold mx-2 mt-6">
                確定拠出年金
              </div>
              <img
                src="/static/images/data_renkei_table_DC.png"
                className="p-2"
                alt=""
              />
              <div className="px-2 pb-4 text-xs text-bluegray-500">
                ※定期預金と保険はアセプラ上では現金として扱われます。
              </div>
            </>
          )}
          <button
            onClick={hide}
            className="bg-white p-4 px-8 text-bluegray-500 text-sm flex justify-center items-center">
            閉じる
          </button>
        </div>
      </Modal>
    </>
  );
};
